module.exports = __webpack_public_path__ + "img/fff.eb4fef87.jpg";